import { type RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
    {
        path: '/payments',
        name: 'payments.index',
        component: () => import('@/views/Payment/Index.vue'),
        meta: { roles: 'dev' },
    },
];

export default routes;
